import React from 'react';
import { Form, Button } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

const RegisterActivityForm = ({ activityData, handleChange, handleSubmit, isLoading, typeSelectRef, handleFileChange }) => (
  <Form onSubmit={handleSubmit}>
    <Form.Group controlId="type">
      <Form.Label>Type</Form.Label>
      <Form.Control
        as="select"
        name="type"
        value={activityData.type}
        onChange={handleChange}
        required
        ref={typeSelectRef}
      >
        <option value="">Select Activity Type</option>
        <option value="running">Running</option>
        <option value="cycling">Cycling</option>
        <option value="hiking">Hiking</option>
        <option value="football">Football</option>
        <option value="badminton">Badminton</option>
        <option value="swimming">Swimming</option>
        <option value="other">Other</option>
      </Form.Control>
    </Form.Group>
    <Form.Group controlId="distance">
      <Form.Label>Distance (in km)</Form.Label>
      <Form.Control
        type="number"
        name="distance"
        value={activityData.distance}
        onChange={handleChange}
        required
      />
    </Form.Group>
    <Form.Group controlId="elevation">
      <Form.Label>Elevation (in meters)</Form.Label>
      <Form.Control
        type="number"
        name="elevation"
        value={activityData.elevation}
        onChange={handleChange}
      />
    </Form.Group>
    <Form.Group controlId="formcalories">
    <Form.Label>Calories Burned (calories)</Form.Label>
    <Form.Control
      type="number"
      name="calories"
      value={activityData.calories}
      onChange={handleChange}
      min="0"
      step="any"
    />
  </Form.Group>
    <Form.Group controlId="duration">
      <Form.Label>Duration (in hours, minutes, and seconds)</Form.Label>
      <div className="d-flex">
        <Form.Control
          type="number"
          name="durationHours"
          value={activityData.durationHours}
          onChange={handleChange}
          required
          placeholder="Hours"
          style={{ marginRight: '10px' }}
        />
        <Form.Control
          type="number"
          name="durationMinutes"
          value={activityData.durationMinutes}
          onChange={handleChange}
          required
          placeholder="Minutes"
          style={{ marginRight: '10px' }}
        />
        <Form.Control
          type="number"
          name="durationSeconds"
          value={activityData.durationSeconds}
          onChange={handleChange}
          required
          placeholder="Seconds"
        />
      </div>
    </Form.Group>
    <Form.Group controlId="date">
      <Form.Label>Date and Time</Form.Label>
      <Flatpickr
        data-enable-time
        value={activityData.date}
        onChange={date => handleChange({ target: { name: 'date', value: date[0] } })}
        options={{
          dateFormat: 'Y-m-d H:i',
          enableTime: true,
          time_24hr: true
        }}
        className="form-control"
        required
      />
    </Form.Group>
    <Form.Group controlId="attachments">
      <Form.Label>Attachments</Form.Label>
      <Form.Control
        type="file"
        name="attachments"
        multiple
        onChange={handleFileChange}
        required
      />
    </Form.Group>
    <Button variant="primary" type="submit" disabled={isLoading}>
      Submit
    </Button>
  </Form>
);

export default RegisterActivityForm;
